// Colors
import palette from 'src/theme/palette';

export default {
  root: {
    backgroundColor: palette.background.default,
    '&:hover': {
      // backgroundColor: primary.light
    },
    '&$focused': {
      // backgroundColor: primary.light
    }
  }
};